var rtlDirection = {
    rtlDirectionDataFilePath: "../../../../app/assets/data/rtlDirection.json",
    data: null,
    direction: "ltr"
}

rtlDirection.init = function () {
    $.ajax({
        url: rtlDirection.rtlDirectionDataFilePath,
        global: false,
        dataType: "json",
        async: true,
        success: function success(data) {
            rtlDirection.data = data;
        },
        error: function fail() {
            console.log("error")
        }
    });
}

rtlDirection.onChangeLanguage = function (language) {
    if ( !!rtlDirection.data ) {
        $("html").attr("lang", language);

        var direction = rtlDirection.data[language];
        rtlDirection.direction = (direction !== undefined ? direction : "ltr");
        $("html").attr("dir", rtlDirection.direction);
    }
}

rtlDirection.languageDocContent = function($content, language) {
    if ( !!rtlDirection.data ) {
        $content.attr("lang", language);

        const direction = rtlDirection.data[language];
        rtlDirection.direction = (direction !== undefined ? direction : "ltr");
        $content.attr("dir", rtlDirection.direction);
    }
}

rtlDirection.isRtl = function (language) {
    if ( !!rtlDirection.data ) {
        var direction = rtlDirection.data[language];
        rtlDirection.direction = (direction !== undefined ? direction : "ltr");
        
        return rtlDirection.direction === "rtl";
    }

    return false;
}